var journalize = require('journalize');

import { capfirst } from 'journalize';

import context from 'Data/text.json';

import find from './utils/find';

// AP-style time with uppercase meridiem, like "9:42 P.M." (or "NOON"), with
// the date in front ("Nov. 3, 2026, 9:42 P.M.") when it wasn't today
export function lastUpdatedFormat(date) {
  const time = journalize.aptime(date).toUpperCase();

  return date.toDateString() === new Date().toDateString()
    ? time
    : `${journalize.apdate(date)}, ${time}`;
}

export function format(num) {
  return num < 10 ? '0' + num : num;
}

export const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

export const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export function APTotalVotesToCount(eevp, total_votes) {
  return eevp > 0 ? Math.round((100 * total_votes)/eevp) : NaN
}

const PARTY_SORT_ORDER = [
  'Republican',
  'Democrat',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];
// This is just the order for the top page
const PARTY_SORT_ORDER_TOP = [
  'Democrat',
  'Republican',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];

// If we need light blue #99d2da; background-color:rgba(153, 210, 218, .1)
// If we need dark blue #325ba8; background-color:rgba(90, 137, 204, .1)

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

export function sort_candidates_by_party(candidates, type) {
  // Headshot graphics at the top of the results page: Democrat first
  if (type == 'top_races')
  {
    return candidates.sort(
      (a, b) =>
        PARTY_SORT_ORDER_TOP.indexOf(a.party) -
        PARTY_SORT_ORDER_TOP.indexOf(b.party)
    );
  }

  else {
    return candidates.sort(
      (a, b) =>
        PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
    );
  }
 
}

export function sort_candidates_by_votes(candidates) {
  return candidates.sort(
    (a, b) =>
      b.votes - a.votes
  );
}

export function alert_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.label_conditionals['zero-results'];
  } else if (vote_pct > 0 && vote_pct <= 50 && cand_num > 1) {
    return context.label_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 90 && cand_num > 1) {
    return context.label_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 90 && cand_num > 1) {
    return context.label_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.label_conditionals['uncontested'];
  }
}

export function alert_winners(result, office) {
  if (result == 'winner' && office != 'President') {
    return context.winner_conditionals['winner'];
  } else if (result == 'winner' && office == 'President') {
    return context.winner_conditionals['winner_prez'];
  } else if (result == 'uncontested') {
    return context.winner_conditionals['uncontested'];
  } else if (result == 'runoff') {
    return context.winner_conditionals['runoff'];
  }
}

export function text_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.text_conditionals['zero-results'];
  } else if (vote_pct > 1 && vote_pct <= 50 && cand_num > 1) {
    return context.text_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 90 && cand_num > 1) {
    return context.text_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 90 && cand_num > 1) {
    return context.text_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.text_conditionals['uncontested'];
  }
}

export function text_conditional_winner_zero(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.text_conditionals['zero-results_winner'];
  } else {
    return ``;
  }
}

export function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' ||
    contest.division_type === 'class' ||
    contest.division_type === 'statewide'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function getDistrictNum(division_type, division_number) {
  return capfirst(division_type) + ' ' + division_number
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide' || contest.division_type === 'seat')
    return '';

  return determineDistrictTitle(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}

// Seat counts for the balance of power chart. Shared by the results page and embeds.
export function prepareBalanceData(data, className, chamber, total, halfway) {
  let republican = 0,
    democrat = 0,
    vacant = 0,
    uncontested_republican = 0,
    uncontested_democrat = 0;

  // Filter out special elections from the balance of power (they won't be in power for long)

  let data_wo_special = data.filter((race) => race.election_type == 'general')

  data_wo_special.forEach((contest) => {
    if (
      contest.contest_result == 'not called' &&
      contest.candidacies.length > 1
    ) {
      vacant++;
    } else if (
      (contest.contest_result == 'not called' ||
        contest.contest_result == 'uncontested') &&
      contest.candidacies.length == 1 &&
      contest.candidacies[0].party == 'Republican'
    ) {
      uncontested_republican++;
    } else if (
      (contest.contest_result == 'not called' ||
        contest.contest_result == 'uncontested') &&
      contest.candidacies.length == 1 &&
      contest.candidacies[0].party == 'Democrat'
    ) {
      uncontested_democrat++;
    } else if (
      contest.contest_result == 'winner' &&
      contest.candidacies.length > 1 &&
      find(contest.candidacies, (candidate) => candidate.is_winner === true) && 
      find(contest.candidacies, (candidate) => candidate.is_winner === true)
        .party == 'Republican'
    ) {
      republican++;
    } else if (
      contest.contest_result == 'winner' &&
      contest.candidacies.length > 1 &&
      find(contest.candidacies, (candidate) => candidate.is_winner === true) && 
      find(contest.candidacies, (candidate) => candidate.is_winner === true)
        .party == 'Democrat'
    ) {
      democrat++;
    }
  });

  return {
    chamber: chamber,
    className: className,
    republican: republican,
    democrat: democrat,
    vacant: vacant,
    halfway: halfway,
    total: total,
    uncontested_republican: uncontested_republican,
    uncontested_democrat: uncontested_democrat,
  };
}
